import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import { clearCreatedFee, createFee } from '../../../store/actions/feesActions';
import TextField from '../../elements/form/TextField';
import TextareaField from '../../elements/form/TextareaField';
import ModalActionButton from '../../elements/ModalActionButton';
import NumberField from '../../elements/form/NumberField';
import SelectField from '../../elements/form/SelectField';
import { Switch } from '@headlessui/react';
import { fetchAccounts } from '../../../store/actions/collegeAccountActions';

const NewFee = ({closeFunction, reload, description}) => {
    const dispatch = useDispatch()
    const feesSelector = useSelector(state => state.fees)
    const accountsSelector = useSelector(state => state.accounts)
    const [feePayload, setFeePayload] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        dispatch(fetchAccounts('', 0, 0))
        if(feesSelector.createdFee !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'new fee created successfully!'
            })
            dispatch(clearCreatedFee())
            closeFunction()
            reload()
            setTimeout(() => {
                setFeePayload({})
                setValidationErrors({})
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [feesSelector.createdFee, dispatch, closeFunction]);

    const validateForm = () => {
        let errors = {}
        if(!feePayload.name || feePayload.name === '') {
            errors.name = true
        }
        if(!feePayload.description || feePayload.description === '') {
            errors.description = true
        }
        if(!feePayload.amount || feePayload.amount === '') {
            errors.amount = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushFee = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(createFee({
                ...feePayload, 
                ...{
                    amount: feePayload.amount * 100,
                    creditToStudent: creditToStudent
                }}))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    const feeTypes = [
        {
            label: 'Admission application fee',
            value: 'ADMISSION_APPLICATION_FEE'
        },
        {
            label: 'Admission acceptance fee',
            value: 'PROVISIONAL_OFFER_ACCEPTANCE'
        },
        {
            label: 'Event fees/dues',
            value: 'EVENT_FEES'
        },
        {
            label: 'Examination fee',
            value: 'EXAMINATION_FEE'
        },
        {
            label: 'School fees',
            value: 'SCHOOL_FEES'
        },
        {
            label: 'Other',
            value: 'OTHER'
        },
    ]

    const [requiresAccount, setRequiresAccount] = useState(false);
    const [creditToStudent, setCreditToStudent] = useState(false)
    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>{description}</p>
            </div>
            <div className='mt-4'>
                <TextField
                    inputLabel="Fee name" 
                    fieldId="fee-name" 
                    inputType="text" 
                    inputPlaceholder={`Name the fee (eg: PTA Fee)`}
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setFeePayload({...feePayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2'>
                <SelectField
                    selectOptions={feeTypes}
                    inputLabel="Select fee type"
                    titleField="label"
                    displayImage={false}
                    imageField=""
                    requiredField={true}
                    preSelectedIndex={''}
                    preSelectedLabel="_id"
                    fieldId="fee-select"
                    hasError={validationErrors && validationErrors.academicSession}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {setFeePayload({...feePayload, ...{feeType: value.value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="fee-description" 
                    inputPlaceholder={`Add a short description for this fee`}
                    inputType="text" 
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setFeePayload({...feePayload, ...{description: value}})}}
                />
            </div>

            <div className='mt-4'>
                <NumberField 
                    inputType="number" 
                    fieldId={`fee-amount`}
                    inputLabel="Fee Amount" 
                    inputPlaceholder={`How much is this fee?`}
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.amount} 
                    returnFieldValue={(value)=>{setFeePayload({...feePayload, ...{amount: value}})}}
                />
            </div>

            <div className="w-full flex justify-between gap-x-4 pt-4 border-secondary border-opacity-50">
                <div className='w-10/12'>
                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Has Designated Account</label>
                    <label className="text-xs text-gray-500 font-sofia-pro">Flip this switch if this fee should be paid into a designated account.</label>
                </div>
                <div className='w-2/12 flex flex-row-reverse pt-[15px]'>
                    <Switch
                        checked={requiresAccount}
                        onChange={()=>{setRequiresAccount(!requiresAccount)}}
                        className={`${
                            requiresAccount ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">Requires fee</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                requiresAccount ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>
            </div>

            {requiresAccount && <div className='mt-2'>
                {accountsSelector.accounts?.accounts?.length > 0 ? 
                    <>
                        <SelectField
                            selectOptions={accountsSelector.accounts?.accounts.map(account => {
                                return {...account, ...{name: `${account.accountName} - ${account.accountNumber} (${account.bankName})`}}
                            })}
                            inputLabel="Select fee account"
                            titleField="name"
                            displayImage={false}
                            imageField=""
                            requiredField={true}
                            preSelectedIndex={''}
                            preSelectedLabel="_id"
                            fieldId="fee-select"
                            hasError={validationErrors && validationErrors.feeAccount}
                            // return id of accounts of the selected option
                            returnFieldValue={(value) => {setFeePayload({...feePayload, ...{feeAccount: value._id}})}}
                        /> 
                        <p className='text-xs text-gray-400 mt-2'>At the point of payment of an invoice, the amount for this fee will be moved to this account.</p>
                    </>
                :
                <div className='w-full bg-red-50 p-3 rounded text-xs text-gray-700 flex items-center'>
                    <p className='text-xs font-[550] text-red-600'>No accounts created yet. Please navigate to "College accounts" above and create accounts before you can designate them as fee accounts.</p>
                </div>
                }
            </div>}


            <div className="w-full flex justify-between gap-x-4 pt-4 border-secondary border-opacity-50">
                <div className='w-10/12'>
                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Credit to student</label>
                    <label className="text-xs text-gray-500 font-sofia-pro inline-block leading-[1.2em]">Flip this switch if the amount on this fee should be credited to the sundry account of any student the fee is assigned to.</label>
                </div>
                <div className='w-2/12 flex flex-row-reverse pt-[15px]'>
                    <Switch
                        checked={creditToStudent}
                        onChange={()=>{setCreditToStudent(!creditToStudent)}}
                        className={`${
                            creditToStudent ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">Requires fee</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                creditToStudent ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create new fee`}
                    buttonAction={()=>{pushFee()}}
                    processing={feesSelector.creatingFee}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewFee